import React from 'react';
import { SpinnerIos16Regular } from '@fluentui/react-icons';
import styles from './css/index.module.css';
import bannerCheck from './assets/banner-check.svg';

const DocumentContextBanner = ({ variant = 'ready', refreshing = false, onDismiss, onRefresh, onNotNow }) => {
    if (!variant) return null;

    if (variant === 'stale') {
        return (
            <div className={styles.docBanner} role="status">
                <span className={styles.docBannerIcon} aria-hidden="true">
                    <img src={bannerCheck} alt="" width={8} height={6} />
                </span>
                <div className={styles.docBannerCopy}>
                    <p className={styles.docBannerTitle}>New project context is available</p>
                    <p className={styles.docBannerText}>
                        {refreshing
                            ? 'Updating recommendations with your processed project documents…'
                            : 'Your uploaded project documents have finished processing. Refresh these recommendations to include the new information.'}
                    </p>
                    <div className={styles.docBannerActions}>
                        <button type="button" className={styles.docBannerRefresh} onClick={onRefresh} disabled={refreshing}>
                            {refreshing ? (
                                <>
                                    <SpinnerIos16Regular className={styles.docBannerRefreshIcon} />
                                    Refreshing recommendations…
                                </>
                            ) : (
                                'Refresh recommendations'
                            )}
                        </button>
                        <button type="button" className={styles.docBannerNotNow} onClick={onNotNow || onDismiss} disabled={refreshing}>
                            Not now
                        </button>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className={styles.docBanner} role="status">
            <span className={styles.docBannerIcon} aria-hidden="true">
                <img src={bannerCheck} alt="" width={8} height={6} />
            </span>
            <div className={styles.docBannerCopy}>
                <p className={styles.docBannerTitle}>Project documents are ready</p>
                <p className={styles.docBannerText}>
                    Lens has finished processing the documents you uploaded. They will now be used in project setup
                    recommendations.
                </p>
            </div>
            <button type="button" className={styles.docBannerDismiss} onClick={onDismiss} aria-label="Dismiss">
                ✕
            </button>
        </div>
    );
};

export default DocumentContextBanner;
